module.exports = __webpack_public_path__ + "media/images/logo-white-c223dcb3864512d6e4146dc2941d179e.png";